import { color } from "@8x8/oxygen-constants";

export const SEMI_BOLD_FONT_WEIGHT = 600;

export const COLORS = Object.freeze({
  primary: color.pickledBluewood800,
  secondary: color.cloudyBlue,
  tertiary: color.cloudyBlue300,
  lightLink: color.dodgerBlue100,
  link: color.dodgerBlue400,
  lightDanger: color.coral200,
  danger: color.coral,
  lightSuccess: color.jadeGreen200,
  success: color.jadeGreen,
  warning: color.goldenBell,
  background: color.white,
  gray10: color.gray10,
  gray: "#C2C2C2",
});

//TODO: Add dark theme colors with helper for providing the right one
